/*
 * Judge.me carousel accessibility fix.
 * I link delle card del carosello recensioni (a.jdgm-carousel-item__product)
 * vengono renderizzati dal widget senza testo accessibile: aggiungiamo un
 * aria-label derivato dal titolo prodotto nella card, con fallback
 * sull'handle prodotto nell'URL.
 */
(function () {
  function labelJdgm() {
    document.querySelectorAll('a.jdgm-carousel-item__product:not([aria-label])').forEach(function (a) {
      var item = a.closest('.jdgm-carousel-item');
      var t = item && item.querySelector('.jdgm-carousel-item__product-title');
      var label = t ? t.textContent.trim() : '';
      if (!label) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
        if (m) label = decodeURIComponent(m[1]).replace(/-/g, ' ');
      }
      a.setAttribute('aria-label', label ? 'Vai al prodotto: ' + label : 'Vai al prodotto');
    });
  }
  new MutationObserver(labelJdgm).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', labelJdgm);
})();
